import type { PlayerState } from "../../../../royalur/model/PlayerState.js";
import type { PlayerType } from "../../../../royalur/model/PlayerType.js";
import { PlayerStateDirective } from "./PlayerStateDirective.js";


/**
 * A directive for rendering the state of the player.
 */
export class BasicPlayerStateDirective extends PlayerStateDirective {
    readonly lightPlayerState: PlayerState;
    readonly darkPlayerState: PlayerState;
    readonly activePlayer: PlayerType;

    constructor(
        directiveID: number,
        moveIndex: number,
        lightPlayerState: PlayerState,
        darkPlayerState: PlayerState,
        activePlayer: PlayerType,
    ) {
        super(directiveID, moveIndex);
        this.lightPlayerState = lightPlayerState;
        this.darkPlayerState = darkPlayerState;
        this.activePlayer = activePlayer;
    }

    override getActivePlayer(_moveIndex: number): PlayerType {
        return this.activePlayer;
    }

    override getLightPlayerState(_moveIndex: number): PlayerState {
        return this.lightPlayerState;
    }

    override getDarkPlayerState(_moveIndex: number): PlayerState {
        return this.darkPlayerState;
    }
}
